import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Anneau de focus clavier partagé (WCAG 2.1 AA). À appliquer sur TOUT élément
 * cliquable custom (carte-lien, ligne, `<summary>`) qui ne passe pas déjà par
 * `<Button>` ou `cardVariants({ interactive: true })`. Voir DESIGN.md.
 */
/** Miroir focus GS (GS_COMPONENTS.input / UI_STANDARDS focus rings brand). */
export const focusRing =
  'outline-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/20'
